/* Magnifixcarp · Mur des prises : affichage des photos, « J'aime », agrandissement, TOP 3 du mois, partage, et formulaire « Envoyer ma prise ».
   Données : script Google du Sheet « Magnifixcarp · Mur des prises » (adresse dans l'extrait mfx-mur-api) :
   GET  → { items: [{ id, pid (profil public, vide si masqué), prenom (prénom + initiale du nom), dept, dept_nom, espece, poids, spot, photo, likes, appat, date, ts }], star: id, gagnant: id }
   POST { action: 'like', id, undo } · POST { action: 'send', … , image: dataURL JPEG }
   « J'aime » déjà donnés : gardés dans le navigateur (clé mfxMurLikes), un seul par photo et par navigateur.
   Département remis sur 2 chiffres (le Sheet peut enregistrer « 03 » comme 3). Carnet du pêcheur : section mfx-carnet.
   TOP 3 du mois : les 3 photos envoyées ce mois-ci (champ date, heure de Paris) qui ont le plus de J'aime ; égalité : la plus ancienne
   devant. Fin du vote : dernier jour du mois à 23:59:59, heure de Paris, avec compte à rebours à la seconde. Seules les prises du mois en cours
   peuvent recevoir un J'aime (le script le vérifie aussi) : les autres gardent un bouton grisé avec le total reçu ; à minuit le mur se redessine.
   Carrousel : défilement continu et lent (environ 25 px/s, en boucle), arrêt au survol, au toucher, au clavier et quand une
   photo est ouverte ; pas de défilement automatique si le visiteur a demandé moins d'animations.
   Partage : window.MfxShare dessine une image 1080 × 1350 (photo + bandeau Magnifixcarp) et l'envoie au partage du téléphone,
   ou la télécharge et copie le lien. Lien direct d'une prise : /?prise=ID#mur-des-prises (ouvre la photo en grand).
   Vitesse (01/11/2026) : photos du carrousel en 500 px et du TOP 3 en 320 px, en priorité basse (la photo de la bannière,
   élément LCP mesuré par PageSpeed, passe avant). Données gardées 24 h dans le navigateur (clé mfxMurCache) pour un affichage immédiat. */
(function () {
  'use strict';
  var LKEY = 'mfxMurLikes';
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  function getLiked() { try { return JSON.parse(localStorage.getItem(LKEY) || '{}') || {}; } catch (e) { return {}; } }
  function setLiked(o) { try { localStorage.setItem(LKEY, JSON.stringify(o)); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function post(api, data) { return fetch(api, { method: 'POST', body: JSON.stringify(data) }).then(function (r) { return r.json(); }); }
  function pic(u, w) { return u + '=w' + w; }
  /* Lien vers le profil public du pêcheur (/pages/pecheur?p=ID), seulement si son profil n'est pas masqué */
  function pfLink(it, label, style) { return /^[0-9a-f]{12}$/.test(it.pid || '') ? '<a href="/pages/pecheur?p=' + it.pid + '" style="' + style + '">' + esc(label) + '</a>' : ''; }
  function savedDept() { try { return localStorage.getItem('mfxMeteoDept') || ''; } catch (e) { return ''; } }
  function dep2(d) { d = String(d == null ? '' : d); return /^\d$/.test(d) ? '0' + d : d; }
  /* Date d'envoi d'une prise en millisecondes (« 31/10/2026 20:19:20 », ou date ISO), sinon date de la prise */
  function stamp(it) {
    if (+it.ts > 0) return +it.ts;
    var d = String(it.date || ''), m = d.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\D+(\d{1,2}):(\d{2}))?/);
    if (m) return parisTime(+m[3], +m[2] - 1, +m[1], +(m[4] || 0), +(m[5] || 0), 0);
    var t = Date.parse(d);
    if (!isNaN(t)) return t;
    t = Date.parse(String(it.date_prise || ''));
    return isNaN(t) ? 0 : t;
  }
  /* Heure de Paris, quel que soit le fuseau du visiteur */
  var PFMT = null;
  function parisParts(t) {
    var o = {};
    try {
      PFMT = PFMT || new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
      PFMT.formatToParts(new Date(t)).forEach(function (p) { if (p.type !== 'literal') o[p.type] = +p.value; });
    } catch (e) { var d = new Date(t); o = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate(), hour: d.getHours(), minute: d.getMinutes(), second: d.getSeconds() }; }
    return o;
  }
  /* Instant (ms) d'une date et heure de Paris (mois de 0 à 11, débordement accepté : mois 12 = janvier suivant) */
  function parisTime(y, mo, d, h, mi, se) {
    var guess = Date.UTC(y, mo, d, h, mi, se), p = parisParts(guess);
    return guess - (Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - guess);
  }
  function monthKey(t) { var p = parisParts(t); return p.year * 12 + p.month - 1; }
  /* Concours : seules les prises du mois en cours (heure de Paris) peuvent recevoir un J’aime */
  function curKey() { var P = parisParts(Date.now()); return P.year * 12 + P.month - 1; }
  function votable(it) { return monthKey(it._t) === curKey(); }
  /* « de novembre », « d’octobre » */
  function deMois(i) { var m = MOIS[i]; return (/^[aeiouéè]/.test(m) ? 'd’' : 'de ') + m; }
  var HEART = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 8 3.3 4.5 6.8 4.5c2 0 3.6 1.1 4.2 2.4h2c.6-1.3 2.2-2.4 4.2-2.4 3.5 0 5.4 3.5 4.1 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';
  var SHARE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4"></path></svg>';
  /* Espèce affichée : « Autre » ou vide → « Carpe » */
  function spc(it) { var e = String(it.espece || '').trim(); return !e || /^autre$/i.test(e) ? 'Carpe' : e; }
  function where(it) { return esc(it.dept_nom) + ' (' + esc(it.dept) + ') · ' + (it.spot ? esc(it.spot) : 'Spot gardé secret'); }
  function likeBtn(it, attrs, cls) {
    var off = !votable(it), n = it.likes || 0;
    return '<button type="button" class="mfx-m-like' + (cls || '') + (off ? ' mfx-m-like--off' : '') + '" ' + attrs + (off ? ' disabled title="Vote terminé : les J’aime sont réservés aux prises du mois en cours"' : '') + ' aria-pressed="' + (!off && !!getLiked()[it.id]) + '" aria-label="' + (off ? 'Vote terminé, ' + n + ' J’aime reçus par la prise de ' : 'J’aime la prise de ') + esc(it.prenom) + '">' + HEART + '<span data-m-count>' + n + '</span></button>';
  }

  /* ---------- Partage : image avec le bandeau Magnifixcarp ---------- */
  function cssVar(name, fallback) {
    var el = document.querySelector('.mfx-h') || document.documentElement;
    var v = getComputedStyle(el).getPropertyValue(name);
    return (v && v.trim()) || fallback;
  }
  function fit(ctx, text, max, size, font) {
    while (size > 18) { ctx.font = font.replace('{s}', size); if (ctx.measureText(text).width <= max) break; size -= 2; }
    return size;
  }
  function drawCard(it, img, label) {
    var W = 1080, H = 1350, P = 1080, c = document.createElement('canvas');
    c.width = W; c.height = H;
    var x = c.getContext('2d');
    var disp = cssVar('--h-display', 'Impact, "Arial Black", sans-serif'), body = getComputedStyle(document.body).fontFamily || 'Arial, sans-serif';
    var accent = '#D9733A', deep = '#0F1F18', cream = '#F1EBDD', muted = '#C9D6CD';
    /* Photo recadrée au carré */
    var s = Math.max(W / img.naturalWidth, P / img.naturalHeight), w = img.naturalWidth * s, h = img.naturalHeight * s;
    x.fillStyle = deep; x.fillRect(0, 0, W, H);
    x.drawImage(img, (W - w) / 2, (P - h) / 2, w, h);
    var g = x.createLinearGradient(0, P - 260, 0, P);
    g.addColorStop(0, 'rgba(15,31,24,0)'); g.addColorStop(1, 'rgba(15,31,24,.55)');
    x.fillStyle = g; x.fillRect(0, P - 260, W, 260);
    /* Badge (Prise du mois, TOP 3) */
    if (label) {
      x.font = '700 30px ' + body;
      var bw = x.measureText(label.toUpperCase()).width + 48;
      x.fillStyle = accent;
      if (x.roundRect) { x.beginPath(); x.roundRect(40, 40, bw, 60, 30); x.fill(); } else x.fillRect(40, 40, bw, 60);
      x.fillStyle = '#fff'; x.textBaseline = 'middle'; x.fillText(label.toUpperCase(), 64, 71);
    }
    /* Bandeau */
    x.fillStyle = deep; x.fillRect(0, P, W, H - P);
    x.fillStyle = accent; x.fillRect(0, P, W, 10);
    x.textBaseline = 'alphabetic';
    var left = 60, right = W - 60, sp = spc(it);
    var big = it.poids ? String(it.poids) : sp;
    x.fillStyle = cream;
    fit(x, big, 520, 104, '400 {s}px ' + disp);
    x.fillText(big, left, P + 128);
    var who = (it.poids ? sp + ' de ' : 'Prise de ') + (it.prenom || '');
    fit(x, who, 560, 40, '700 {s}px ' + body);
    x.fillText(who, left, P + 190);
    x.fillStyle = muted;
    var loc = it.dept_nom ? it.dept_nom + (it.dept ? ' (' + it.dept + ')' : '') : '';
    fit(x, loc, 560, 32, '400 {s}px ' + body);
    x.fillText(loc, left, P + 236);
    x.textAlign = 'right';
    x.fillStyle = accent;
    fit(x, 'MAGNIFIXCARP', 400, 54, '400 {s}px ' + disp);
    x.fillText('MAGNIFIXCARP', right, P + 128);
    x.fillStyle = cream; x.font = '700 30px ' + body;
    x.fillText('magnifixcarp.com', right, P + 186);
    x.fillStyle = muted; x.font = '400 28px ' + body;
    x.fillText('Le mur des prises', right, P + 230);
    return c;
  }
  /* Promesse d'un Blob JPEG (rejetée si la photo ne peut pas être dessinée) */
  function cardBlob(it, label) {
    return new Promise(function (res, rej) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        var go = function () {
          try { drawCard(it, im, label).toBlob(function (b) { if (b) res(b); else rej(new Error('blob')); }, 'image/jpeg', 0.9); } catch (e) { rej(e); }
        };
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(go, go); else go();
      };
      im.onerror = function () { rej(new Error('image')); };
      im.src = pic(it.photo, 1600);
    });
  }
  function link(it) { return location.origin + '/?prise=' + encodeURIComponent(it.id || '') + '#mur-des-prises'; }
  function copy(t) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(t).then(function () { return true; }, function () { return false; });
    return Promise.resolve(false);
  }
  function download(blob, name) {
    var a = document.createElement('a'), u = URL.createObjectURL(blob);
    a.href = u; a.download = name; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(u); }, 4000);
  }
  /* Partage d'une prise. ready : Blob déjà préparé (le partage du téléphone doit partir juste après le toucher). say(texte) : message */
  function share(it, ready, say, label) {
    var url = it.id ? link(it) : location.origin + '/#mur-des-prises';
    var text = spc(it) + (it.poids ? ' de ' + it.poids : '') + ' prise par ' + (it.prenom || 'un lecteur') + ' sur le mur des prises Magnifixcarp. Mets-lui un J’aime !';
    say = say || function () {};
    function withBlob(blob) {
      var file = null;
      try { file = new File([blob], 'prise-magnifixcarp.jpg', { type: 'image/jpeg' }); } catch (e) {}
      if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
        return navigator.share({ files: [file], title: 'Ma prise sur Magnifixcarp', text: text + ' ' + url }).catch(function (e) {
          if (e && e.name === 'AbortError') return;
          download(blob, 'prise-magnifixcarp.jpg'); return copy(url).then(function (ok) { say(ok ? 'Image téléchargée, lien copié.' : 'Image téléchargée.'); });
        });
      }
      download(blob, 'prise-magnifixcarp.jpg');
      return copy(url).then(function (ok) { say(ok ? 'Image téléchargée et lien copié : colle-le avec ta photo !' : 'Image téléchargée.'); });
    }
    function noImage() {
      if (navigator.share) return navigator.share({ title: 'Ma prise sur Magnifixcarp', text: text, url: url }).catch(function () {});
      return copy(url).then(function (ok) { say(ok ? 'Lien copié : colle-le où tu veux !' : url); });
    }
    if (ready) return withBlob(ready);
    say('Préparation de l’image…');
    return cardBlob(it, label).then(function (b) { say(''); return withBlob(b); }, noImage);
  }
  window.MfxShare = { blob: cardBlob, share: share, link: link };

  /* ---------- Le mur ---------- */
  function initMur(sec) {
    if (sec.dataset.mInit) return;
    sec.dataset.mInit = '1';
    var api = sec.getAttribute('data-api');
    if (!api) return;
    var track = sec.querySelector('[data-m-track]'), car = sec.querySelector('[data-m-carousel]');
    var launch = sec.querySelector('[data-m-launch]'), tabs = sec.querySelector('[data-m-tabs]'), box = sec.querySelector('[data-m-box]');
    var prev = sec.querySelector('[data-m-prev]'), next = sec.querySelector('[data-m-next]'), navBox = sec.querySelector('[data-m-nav]');
    var top3 = sec.querySelector('[data-m-top3]');
    var data = [], star = '', gagnant = '', order = [], rank = {}, boxBlob = null, boxId = '';

    function badgeOf(it) {
      if (it.id === star) return 'Prise du mois';
      if (rank[it.id]) return 'TOP 3 du mois · n°' + rank[it.id];
      return '';
    }
    function card(it) {
      var who = spc(it) + ' de ' + it.prenom, isStar = it.id === star;
      return '<figure class="mfx-h-prise' + (isStar ? ' mfx-h-prise--star' : '') + '" data-id="' + esc(it.id) + '">' +
        '<button type="button" class="mfx-m-open" data-m-open aria-label="Agrandir : ' + esc(who) + '"><img src="' + esc(pic(it.photo, 500)) + '" alt="' + esc(who + ', ' + it.dept_nom) + '" loading="lazy" decoding="async" fetchpriority="low" width="500" height="500"></button>' +
        (isStar ? '<span class="mfx-h-prise__badge">Prise du mois</span>' : (rank[it.id] ? '<span class="mfx-h-prise__badge">TOP 3 · n°' + rank[it.id] + '</span>' : '')) +
        '<figcaption class="mfx-h-prise__info">' + (it.poids ? '<span class="mfx-h-prise__kg">' + esc(it.poids) + '</span>' : '') +
        '<span class="mfx-h-prise__who">' + esc(who) + '</span><span class="mfx-h-prise__where">' + where(it) + '</span></figcaption>' +
        likeBtn(it, 'data-m-like') + '</figure>';
    }
    function nav() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = !auto.loop && track.scrollLeft <= 2;
      next.disabled = !auto.loop && track.scrollLeft >= max;
      navBox.hidden = max <= 0;
    }
    /* ----- Défilement automatique ----- */
    var SPEED = 0.025; /* px par milliseconde */
    var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
    var auto = { raf: 0, pos: 0, last: 0, loop: false, hold: {}, timer: 0 };
    function held() { for (var k in auto.hold) if (auto.hold[k]) return true; return false; }
    function hold(k, on) { auto.hold[k] = on; if (!on) { auto.pos = track.scrollLeft; auto.last = 0; } }
    function holdFor(k, ms) { hold(k, true); clearTimeout(auto.timer); auto.timer = setTimeout(function () { hold(k, false); }, ms); }
    function step(t) {
      auto.raf = requestAnimationFrame(step);
      if (held() || document.hidden) { auto.last = 0; return; }
      var dt = auto.last ? Math.min(64, t - auto.last) : 0;
      auto.last = t;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 1 || !dt) return;
      auto.pos += dt * SPEED;
      if (auto.loop) { var half = track.scrollWidth / 2; if (auto.pos >= half) auto.pos -= half; }
      else if (auto.pos >= max) auto.pos = 0;
      track.scrollLeft = auto.pos;
    }
    /* Copie de la liste à la suite quand elle déborde : la boucle ne s'arrête jamais */
    function setupLoop() {
      cancelAnimationFrame(auto.raf);
      auto.loop = false; auto.pos = 0; auto.last = 0;
      track.classList.remove('is-auto');
      if (reduce) return;
      var cards = track.querySelectorAll('.mfx-h-prise');
      if (!cards.length || track.scrollWidth - track.clientWidth <= 2) return;
      var copy = Array.prototype.map.call(cards, function (c) {
        var k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); k.classList.add('is-copy');
        k.querySelectorAll('button').forEach(function (b) { b.tabIndex = -1; });
        return k;
      });
      copy.forEach(function (k) { track.appendChild(k); });
      auto.loop = true;
      track.classList.add('is-auto');
      auto.raf = requestAnimationFrame(step);
    }
    car.addEventListener('mouseenter', function () { hold('hover', true); });
    car.addEventListener('mouseleave', function () { hold('hover', false); });
    car.addEventListener('focusin', function () { hold('focus', true); });
    car.addEventListener('focusout', function (e) { if (!car.contains(e.relatedTarget)) hold('focus', false); });
    track.addEventListener('touchstart', function () { clearTimeout(auto.timer); hold('touch', true); }, { passive: true });
    track.addEventListener('touchend', function () { holdFor('touch', 4000); }, { passive: true });
    if (box) box.addEventListener('close', function () { hold('box', false); boxId = ''; });
    function jump(dir) {
      holdFor('nav', 5000);
      var w = track.clientWidth * 0.9 * dir, half = track.scrollWidth / 2;
      if (auto.loop) {
        if (dir < 0 && track.scrollLeft + w < 0) track.scrollLeft += half;
        else if (dir > 0 && track.scrollLeft + w > half) track.scrollLeft -= half;
      }
      track.scrollBy({ left: w, behavior: 'smooth' });
    }
    function byId(id) { for (var i = 0; i < data.length; i++) if (data[i].id === id) return data[i]; return null; }
    prev.addEventListener('click', function () { jump(-1); });
    next.addEventListener('click', function () { jump(1); });
    track.addEventListener('scroll', nav, { passive: true });
    window.addEventListener('resize', nav);

    var curMode = 'all';
    function filter(mode) {
      curMode = mode;
      tabs.querySelectorAll('[data-m-tab]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-m-tab') === mode); });
      var list = order.slice();
      if (mode === 'dep') { var d = savedDept(); list = list.filter(function (it) { return it.dept === d; }); }
      else if (mode === 'top') list.sort(function (a, b) { return (b.likes || 0) - (a.likes || 0); });
      track.innerHTML = list.length ? list.map(card).join('') : '<p class="mfx-m-empty">Pas encore de prise dans ton département. <a href="' + esc(sec.getAttribute('data-send')) + '">Envoie la première !</a></p>';
      track.scrollLeft = 0;
      setupLoop();
      nav();
    }
    tabs.addEventListener('click', function (e) { var b = e.target.closest('[data-m-tab]'); if (b) filter(b.getAttribute('data-m-tab')); });

    /* ----- TOP 3 du mois ----- */
    function ranking(key) {
      return data.filter(function (it) { return monthKey(it._t) === key; })
        .sort(function (a, b) { return ((b.likes || 0) - (a.likes || 0)) || (a._t - b._t); });
    }
    function renderTop3() {
      if (!top3) return;
      var P = parisParts(Date.now()), key = P.year * 12 + P.month - 1, list = ranking(key).slice(0, 3), last = (gagnant && byId(gagnant)) || ranking(key - 1)[0];
      rank = {};
      list.forEach(function (it, i) { rank[it.id] = i + 1; });
      var listBox = top3.querySelector('[data-m-top3-list]'), lastBox = top3.querySelector('[data-m-top3-last]');
      var mEl = top3.querySelector('[data-m-top3-month]'); if (mEl) mEl.parentNode.textContent = 'Le TOP 3 ' + deMois(P.month - 1);
      /* Fin du vote : dernier jour du mois à 23:59:59, heure de Paris */
      var end = parisTime(P.year, P.month, 1, 0, 0, 0) - 1000, endP = parisParts(end);
      top3.querySelector('[data-m-top3-left]').textContent = 'Concours du mois · fin le ' + endP.day + ' ' + MOIS[endP.month - 1] + ' à 23:59:59';
      startTimer(end);
      if (list.length) {
        listBox.innerHTML = list.map(function (it, i) {
          var who = spc(it) + ' de ' + it.prenom;
          return '<li class="mfx-h-top3__item mfx-h-top3__item--' + (i + 1) + '" data-id="' + esc(it.id) + '">' +
            '<button type="button" class="mfx-h-top3__pic" data-m-open aria-label="Agrandir : ' + esc(who) + ' (n°' + (i + 1) + ')">' +
            '<img src="' + esc(pic(it.photo, 320)) + '" alt="' + esc(who + ', ' + it.dept_nom) + '" loading="lazy" decoding="async" fetchpriority="low" width="320" height="320">' +
            '<span class="mfx-h-top3__rank">' + (i + 1) + '</span></button>' +
            '<div class="mfx-h-top3__txt"><b>' + (/^[0-9a-f]{12}$/.test(it.pid || '') ? '<a href="/pages/pecheur?p=' + it.pid + '" style="text-decoration:underline;text-underline-offset:3px">' + esc(it.prenom) + '</a>' : esc(it.prenom)) + '</b><span>' + (it.poids ? esc(it.poids) + ' · ' : '') + esc(spc(it)) + ' · ' + esc(it.dept_nom) + '</span></div>' +
            likeBtn(it, 'data-m-like', ' mfx-m-like--top3') + '</li>';
        }).join('');
        listBox.hidden = false;
      } else {
        listBox.innerHTML = ''; listBox.hidden = true;
      }
      top3.querySelector('[data-m-top3-empty]').hidden = !!list.length;
      if (last) {
        lastBox.innerHTML = 'Gagnant ' + deMois(parisParts(last._t).month - 1) + ' : <b>' + esc(last.prenom) + '</b>' + (last.poids ? ', ' + esc(last.poids) : '') + ' · ' + esc(last.dept_nom) + ' · ' + (last.likes || 0) + ' J’aime';
        lastBox.hidden = false;
      } else lastBox.hidden = true;
      top3.hidden = false;
    }
    var timerId = 0;
    function startTimer(end) {
      var box = top3.querySelector('[data-m-top3-timer]');
      if (!box) return;
      var U = {}; box.querySelectorAll('[data-t]').forEach(function (el) { U[el.getAttribute('data-t')] = el; });
      var lab = box.querySelector('[data-m-top3-tl]');
      function two(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
        U.d.textContent = d; U.h.textContent = two(h); U.m.textContent = two(m); U.s.textContent = two(s);
        U.dl.textContent = d > 1 ? 'jours' : 'jour';
        if (!left) { clearInterval(timerId); lab.textContent = 'Vote terminé ! Le gagnant est prévenu par e-mail.'; box.classList.add('is-over'); setTimeout(function () { renderTop3(); filter(curMode); var dlg = sec.querySelector('[data-m-box]'); if (boxId && dlg && dlg.open) open(boxId); }, 1500); }
        else if (left < 86400) { lab.textContent = 'Dernier jour pour voter !'; box.classList.add('is-last'); }
        else lab.textContent = 'Fin du vote dans';
      }
      clearInterval(timerId);
      tick();
      timerId = setInterval(tick, 1000);
      box.hidden = false;
    }
    top3 && top3.addEventListener('click', function (e) {
      var f = e.target.closest('[data-id]'); if (!f) return;
      if (e.target.closest('[data-m-like]')) like(f.getAttribute('data-id'));
      else if (e.target.closest('[data-m-open]')) open(f.getAttribute('data-id'));
    });

    function like(id) {
      var it = byId(id); if (!it || !votable(it)) return; /* vote réservé aux prises du mois en cours */
      var L = getLiked(), undo = !!L[id];
      if (undo) delete L[id]; else L[id] = 1;
      setLiked(L);
      it.likes = Math.max(0, (it.likes || 0) + (undo ? -1 : 1));
      var sel = '[data-id="' + id + '"] [data-m-like], [data-m-box-like][data-for="' + id + '"]';
      document.querySelectorAll(sel).forEach(function (b) {
        b.setAttribute('aria-pressed', !undo);
        b.querySelector('[data-m-count]').textContent = it.likes;
        if (!undo) { b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop'); }
      });
      post(api, { action: 'like', id: id, undo: undo }).then(function (r) {
        if (r && r.ferme) { var L2 = getLiked(); delete L2[id]; setLiked(L2); it.likes = typeof r.likes === 'number' ? r.likes : it.likes; renderTop3(); filter(curMode); return; }
        if (r && r.ok && typeof r.likes === 'number') {
          it.likes = r.likes;
          document.querySelectorAll(sel).forEach(function (b) { b.querySelector('[data-m-count]').textContent = r.likes; });
        }
      }).catch(function () {});
    }
    function boxSay(t) { var m = box && box.querySelector('[data-m-share-msg]'); if (m) { m.textContent = t; m.hidden = !t; } }
    function open(id) {
      var it = byId(id); if (!it || !box) return;
      var who = spc(it) + ' de ' + it.prenom;
      box.querySelector('[data-m-box-body]').innerHTML =
        '<img src="' + esc(pic(it.photo, 1600)) + '" alt="' + esc(who + ', ' + it.dept_nom) + '">' +
        '<div class="mfx-m-box__info"><div>' + (it.poids ? '<b class="mfx-m-box__kg">' + esc(it.poids) + '</b>' : '') +
        '<b>' + esc(who) + '</b><span>' + where(it) + (it.appat ? ' · ' + esc(it.appat) : '') + '</span>' + pfLink(it, 'Voir le profil de ' + it.prenom + ' →', 'display:inline-block;margin-top:6px;font-weight:700;text-decoration:underline;text-underline-offset:3px;color:var(--h-accent,#D9733A)') + '</div>' +
        '<div class="mfx-m-box__acts"><button type="button" class="mfx-m-like mfx-m-like--box mfx-m-share" data-m-share aria-label="Partager la prise de ' + esc(it.prenom) + '">' + SHARE + '<span>Partager</span></button>' +
        likeBtn(it, 'data-m-box-like data-for="' + esc(it.id) + '"', ' mfx-m-like--box') + '</div></div>' +
        '<p class="mfx-m-box__msg" data-m-share-msg role="status" hidden></p>';
      hold('box', true);
      if (box.showModal) box.showModal(); else box.setAttribute('open', '');
      /* Image de partage préparée tout de suite : le partage du téléphone part ensuite dès le toucher */
      boxBlob = null; boxId = it.id;
      cardBlob(it, badgeOf(it)).then(function (b) { if (boxId === it.id) boxBlob = b; }, function () {});
    }
    if (box) box.addEventListener('click', function (e) {
      if (e.target === box || e.target.closest('[data-m-close]')) { if (box.close) box.close(); else { box.removeAttribute('open'); hold('box', false); } return; }
      var b = e.target.closest('[data-m-box-like]'); if (b) { like(b.getAttribute('data-for')); return; }
      if (e.target.closest('[data-m-share]')) { var it = byId(boxId); if (it) share(it, boxBlob, boxSay, badgeOf(it)); }
    });
    track.addEventListener('click', function (e) {
      var f = e.target.closest('[data-id]'); if (!f) return;
      if (e.target.closest('[data-m-like]')) like(f.getAttribute('data-id'));
      else if (e.target.closest('[data-m-open]')) open(f.getAttribute('data-id'));
    });

    var wanted = '';
    try {
      wanted = new URLSearchParams(location.search).get('prise') || '';
      if (!wanted) { var h = location.hash.match(/^#prise-([\w-]+)/); wanted = h ? h[1] : ''; }
    } catch (e) {}
    /* Affichage des données du script. Le bloc d'attente (photo « La première du mur ») est masqué par mfx-home-4.css
       tant que le mur n'est pas prêt (classe is-ready) : il n'apparaît que si le mur est vide ou injoignable. */
    var CKEY = 'mfxMurCache', shown = '';
    function ready() { sec.classList.add('is-ready'); }
    function apply(j, raw) {
      if (raw && raw === shown) return;
      shown = raw || '';
      data = ((j && j.items) || []).map(function (it) { it.id = String(it.id); it.dept = dep2(it.dept); it._t = stamp(it); return it; });
      star = String((j && j.star) || '');
      gagnant = String((j && j.gagnant) || ''); /* gagnant officiel du mois précédent, désigné par le script */
      if (!data.length) return;
      renderTop3();
      var s = byId(star);
      order = s ? [s].concat(data.filter(function (x) { return x !== s; })) : data.slice();
      launch.hidden = true; car.hidden = false; tabs.hidden = false;
      var depTab = tabs.querySelector('[data-m-tab="dep"]'); if (depTab) depTab.hidden = !savedDept();
      filter('all');
      ready();
      if (wanted && byId(wanted)) { sec.scrollIntoView({ block: 'start' }); open(wanted); wanted = ''; }
    }
    /* Visite suivante : le podium et le carrousel s'affichent tout de suite avec les données gardées dans le navigateur
       (moins de 24 h), puis sont mis à jour dès que le script répond. */
    try {
      var c = JSON.parse(localStorage.getItem(CKEY) || 'null');
      if (c && c.j && Date.now() - c.at < 864e5) apply(c.j, c.raw);
    } catch (e) {}
    function load() {
      fetch(api).then(function (r) { return r.text(); }).then(function (raw) {
        var j = JSON.parse(raw);
        try { localStorage.setItem(CKEY, JSON.stringify({ at: Date.now(), raw: raw, j: j })); } catch (e) {}
        apply(j, raw);
        ready();
      }).catch(ready);
    }
    if (wanted || !('IntersectionObserver' in window)) load();
    else {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '600px' });
      io.observe(sec);
    }
  }

  /* ---------- Formulaire « Envoyer ma prise » ---------- */
  function shrink(file) {
    return new Promise(function (res, rej) {
      var url = URL.createObjectURL(file), im = new Image();
      im.onload = function () {
        var max = 1600, w = im.naturalWidth, h = im.naturalHeight, s = Math.min(1, max / Math.max(w, h));
        var c = document.createElement('canvas');
        c.width = Math.round(w * s); c.height = Math.round(h * s);
        c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        res(c.toDataURL('image/jpeg', 0.85)); /* image redessinée : la position GPS de la photo d'origine ne suit pas */
      };
      im.onerror = function () { URL.revokeObjectURL(url); rej(new Error('image')); };
      im.src = url;
    });
  }
  function initForm(form) {
    if (form.dataset.mInit) return;
    form.dataset.mInit = '1';
    var wrap = form.closest('[data-m-send]'), done = wrap.querySelector('[data-m-done]');
    var sel = form.querySelector('[name="dept"]'), file = form.querySelector('[name="photo"]'), prev = form.querySelector('[data-m-preview]');
    var secret = form.querySelector('[name="secret"]'), spotRow = form.querySelector('[data-m-spot]');
    var msg = form.querySelector('[data-m-msg]'), btn = form.querySelector('[type="submit"]');
    var PREF = (window.MfxHData && window.MfxHData.PREF) || '', saved = savedDept();
    PREF.split(';').forEach(function (s) {
      var p = s.split('|'); if (!p[0] || !p[1]) return;
      var o = document.createElement('option'); o.value = p[0]; o.textContent = p[1] + ' (' + p[0] + ')'; o.setAttribute('data-nom', p[1]);
      if (p[0] === saved) o.selected = true;
      sel.appendChild(o);
    });
    var dIn = form.querySelector('[data-m-date]');
    if (dIn) {
      var t = new Date(), iso = new Date(t.getTime() - t.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
      dIn.max = iso; dIn.defaultValue = iso; dIn.value = iso;
    }
    /* Heure de la touche : deux listes (heures, minutes) + bouton « Maintenant » (date et heure du moment) */
    var hh = form.querySelector('[data-m-hh]'), mm = form.querySelector('[data-m-mm]'), hIn = form.querySelector('[data-m-heure]'), nowBtn = form.querySelector('[data-m-now]');
    function syncHeure() { if (hIn) hIn.value = hh && hh.value ? hh.value + ':' + (mm.value || '00') : ''; }
    if (hh) { hh.addEventListener('change', function () { if (hh.value && !mm.value) mm.value = '00'; syncHeure(); }); mm.addEventListener('change', syncHeure); }
    if (nowBtn) nowBtn.addEventListener('click', function () {
      var n = new Date(), two = function (v) { return (v < 10 ? '0' : '') + v; };
      if (dIn) dIn.value = new Date(n.getTime() - n.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
      hh.value = two(n.getHours()); mm.value = two(Math.floor(n.getMinutes() / 5) * 5);
      syncHeure();
      nowBtn.classList.remove('is-done'); void nowBtn.offsetWidth; nowBtn.classList.add('is-done');
    });
    function showSpot() { spotRow.hidden = secret.checked; }
    secret.addEventListener('change', showSpot); showSpot();
    file.addEventListener('change', function () {
      var f = file.files && file.files[0];
      if (!f) { prev.hidden = true; return; }
      prev.innerHTML = '<img src="' + URL.createObjectURL(f) + '" alt="Aperçu de ta photo">';
      prev.hidden = false;
    });
    function say(t, bad) { msg.textContent = t; msg.classList.toggle('is-bad', !!bad); msg.hidden = !t; }
    function val(n) { var el = form.elements[n]; return (el && el.value || '').trim(); }
    function on(n) { return !!(form.elements[n] && form.elements[n].checked); }
    function pick(n) { return (form.querySelector('[name="' + n + '"]:checked') || {}).value || ''; }
    /* Newsletter cochée : inscription Shopify (client avec consentement marketing), comme le formulaire du bas de page.
       Étiquettes (01/11/2026) : newsletter, mur-des-prises, concours-AAAA-MM (mois du concours, heure de Paris), dept-XX,
       + 1er-concours si c'est sa première photo (réponse « premier » du script). */
    function subscribe(email, dept, premier) {
      var nl = document.getElementById('MfxSendNl');
      if (!nl) return;
      var mois = '';
      try {
        var pp = {};
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit' }).formatToParts(new Date()).forEach(function (x) { pp[x.type] = x.value; });
        mois = pp.year + '-' + pp.month;
      } catch (e) {}
      var tags = ['newsletter', 'mur-des-prises'];
      if (/^\d{4}-\d{2}$/.test(mois)) tags.push('concours-' + mois);
      if (premier) tags.push('1er-concours');
      if (dept) tags.push('dept-' + dept);
      nl.querySelector('[data-m-nl-email]').value = email;
      nl.querySelector('[data-m-nl-tags]').value = tags.join(', ');
      fetch(nl.action, { method: 'POST', body: new FormData(nl), credentials: 'same-origin' }).catch(function () {});
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      say('');
      var api = form.getAttribute('data-api');
      if (!api) { say('L’envoi des photos ouvre très bientôt. Reviens dans quelques jours !', true); return; }
      var f = file.files && file.files[0];
      if (!f) { say('Ajoute ta photo.', true); return; }
      if (!val('prenom')) { say('Indique ton prénom.', true); form.elements.prenom.focus(); return; }
      if (!val('nom')) { say('Indique ton nom.', true); form.elements.nom.focus(); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val('email'))) { say('Indique une adresse e-mail valide.', true); form.elements.email.focus(); return; }
      if (!sel.value) { say('Choisis ton département.', true); sel.focus(); return; }
      if (dIn && !dIn.value) { say('Indique la date de ta prise.', true); dIn.focus(); return; }
      var missing = [].filter.call(form.querySelectorAll('.mfx-send__checks input[type="checkbox"]'), function (c) { return !c.checked; });
      if (missing.length) { say('Coche ' + (missing.length > 1 ? 'les ' + missing.length + ' cases restantes' : 'la case restante') + ' pour envoyer ta prise.', true); missing[0].focus(); return; }
      btn.disabled = true; btn.textContent = 'Envoi en cours…';
      var poids = val('poids').replace('.', ',');
      if (/^\d+(,\d+)?$/.test(poids)) poids += ' kg';
      var heure = val('heure_prise');
      if (!/^\d{2}:\d{2}$/.test(heure)) heure = '';
      var email = val('email').toLowerCase(), news = on('newsletter');
      shrink(f).then(function (img) {
        return post(api, {
          action: 'send', image: img, prenom: val('prenom'), nom: val('nom'), email: email, instagram: val('instagram'),
          dept: sel.value, dept_nom: sel.options[sel.selectedIndex].getAttribute('data-nom') || '',
          espece: pick('espece') || 'Carpe', appat: pick('appat'), appat_detail: val('appat_detail'), date_prise: val('date_prise'), heure_prise: heure, poids: poids,
          secret: secret.checked, spot: val('spot'), droits: on('droits'), bienetre: on('bienetre'), accord: on('accord'),
          majeur: on('majeur'), regles: on('regles'), newsletter: news, site: val('site')
        });
      }).then(function (r) {
        if (r && r.ok) {
          try { localStorage.setItem('mfxMeteoDept', sel.value); } catch (e) {}
          if (news) subscribe(email, sel.value, !!r.premier);
          done.hidden = false; form.hidden = true;
          wrap.scrollIntoView({ block: 'start' });
        } else {
          var why = r && r.error;
          say(why === 'quota' ? 'Beaucoup d’envois aujourd’hui : réessaie demain.' : why === 'taille' ? 'Ta photo est trop lourde. Essaie avec une autre.' : why === 'email' ? 'Indique une adresse e-mail valide.' : why === 'accord' ? 'Coche toutes les cases de confirmation pour envoyer ta prise.' : 'L’envoi n’a pas marché. Réessaie dans un moment.', true);
        }
      }).catch(function () {
        say('Impossible de lire ou d’envoyer cette photo. Essaie avec une photo JPEG, ou réessaie dans un moment.', true);
      }).then(function () { btn.disabled = false; btn.textContent = 'Envoyer ma prise'; });
    });
    wrap.querySelector('[data-m-again]').addEventListener('click', function () {
      form.reset(); prev.hidden = true; showSpot(); say(''); syncHeure();
      done.hidden = true; form.hidden = false;
    });
  }

  function init() {
    document.querySelectorAll('[data-m-mur]').forEach(initMur);
    document.querySelectorAll('[data-m-form]').forEach(initForm);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
